<template>
  <div class="hero is-large checkout-hero">
    <div class="hero-banner__dots"></div>
    <div class="container" v-if="current3DFile">
      <div class="columns is-gapless">
        <div class="column is-three-fifths-desktop">
          <div class="py-5 pr-4">
            <div class="hero__controls hero__controls--top">
              <div class="columns is-gapless is-vcentered">
                <div
                  class="column is-one-quarter"
                  @click="currentAnalysisTool = 'Canvas3D'"
                >
                  <CreateNewPrintItemButton>
                    <SvgIcon
                      icon="icon--directional_arrow-left"
                      class="is-primary-dark mr-4"
                    />
                    <strong class="is-size-5 has-text-primary-dark">{{
                      $t("checkout.upload.chooseDifferent3DFile")
                    }}</strong>
                  </CreateNewPrintItemButton>
                </div>
                <div class="column is-three-quarters">
                  <PrintQualityInfo />
                </div>
              </div>
            </div>
            <div class="columns is-gapless">
              <div
                class="
                  preview-tab-switch
                  column
                  is-one-fifth is-one-quarter-desktop
                "
                v-if="
                  current3DFile.givenUnitOfLength &&
                    typeof currentCartItem.scale === 'number'
                "
              >
                <div @click="currentAnalysisTool = 'Canvas3D'">
                  <a
                    class="is-size-2 tab-nav-item "
                    :class="{ 'is-active': currentAnalysisTool === 'Canvas3D' }"
                  >
                    <SvgIcon
                      icon="icon--directional_rotate-3-axis"
                      class="is-primary-dark"
                    />
                  </a>
                  <span class="has-text-primary-dark">{{
                    $t("checkout.configure.3dRender")
                  }}</span>
                </div>
                <div
                  v-if="!current3DFile.repairInfo"
                  @click="currentAnalysisTool = 'HistogramPictures'"
                >
                  <a
                    class="is-size-3 tab-nav-item"
                    :class="{
                      'is-active': currentAnalysisTool === 'HistogramPictures',
                    }"
                  >
                    <SvgIcon
                      icon="icon--web-application_bar-chart"
                      class="is-primary-dark"
                    />
                  </a>
                  <span class="has-text-primary-dark">{{
                    $t("checkout.configure.wallThicknesses")
                  }}</span>
                </div>
                <div
                  v-if="current3DFile.repairInfo"
                  @click="repairModelIsOpen = true"
                >
                  <a
                    class="is-size-3 tab-nav-item"
                    :class="{
                      'is-active': currentAnalysisTool === 'RepairAnalysisInfo',
                    }"
                  >
                    <SvgIcon
                      icon="icon--web-application_warning"
                      class="is-light"
                    />
                  </a>
                  <span>{{ $t("checkout.configure.repairData") }}</span>
                </div>
              </div>
              <div
                class="column"
                :class="{
                  'is-full': currentConfigure3DStep === 0,
                  'is-four-fifths is-three-quarters-desktop':
                    currentConfigure3DStep === 1,
                }"
              >
                <transition name="fade" mode="out-in">
                  <component :is="currentAnalysisTool"></component>
                </transition>
              </div>
            </div>
            <div
              class="hero__controls hero__controls--bottom columns"
              v-if="
                current3DFile.givenUnitOfLength &&
                  typeof currentCartItem.scale === 'number' &&
                  currentOrderProcessStep !== 'view-cart'
              "
            >
              <Configure3DModelScale
                class="column is-narrow is-one-fifth"
              ></Configure3DModelScale>
              <Configure3DModelScaleUnits
                v-if="currentViewport === 'desktop' || 'full-hd'"
                class="column is-two-thirds"
              ></Configure3DModelScaleUnits>
              <SvgIcon
                :grow-by-height="true"
                icon="icon--directional_rotate-3-axis"
                title="Drehen Sie das Objekt durch ziehen mit der Maus"
                class="is-light is-size-1 column is-narrow"
              ></SvgIcon>
            </div>
          </div>
        </div>
        <div class="column is-two-fifths-desktop">
          <Checkout :has-preview="false"></Checkout>
        </div>
      </div>
    </div>
    <div
      class="hero__controls hero__controls--top-right"
      @click="minimizeCheckout()"
    >
      <SvgIcon
        icon="icon--directional_cross"
        class="is-size-2 is-primary"
        title="Schließen"
      ></SvgIcon>
    </div>
    <b-modal
      v-model="repairModelIsOpen"
      transition="expand"
      :can-cancel="false"
      width="640px"
    >
      <template>
        <repair-analysis-info></repair-analysis-info>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Canvas3D from "./Canvas3D";
import PrintQualityInfo from "../shared/PrintQualityInfo";
import Checkout from "./Checkout";
import { mapGetters } from "vuex";
import CreateNewPrintItemButton from "./CreateNewPrintItemButton";
import SvgIcon from "../svg/SvgIcon";
import Configure3DModelScale from "./Configure3DModelScale";
import Configure3DModelScaleUnits from "./Configure3DModelScaleUnits";
import OrderProcessStepSwitch from "./OrderProcessStepSwitch";
import HistogramPictures from "./3d-dashboard/HistogramPictures";
import RepairAnalysisInfo from "./3d-dashboard/RepairAnalysisInfo";
import { eventBus } from "../../events/event-bus";
import UploadNewItemDropArea from "./3d-dashboard/UploadNewItemDropArea";
import ModalView from "../shared/ModalView";

export default {
  name: "CheckoutHero",
  components: {
    OrderProcessStepSwitch,
    SvgIcon,
    CreateNewPrintItemButton,
    Checkout,
    PrintQualityInfo,
    Canvas3D,
    Configure3DModelScale,
    Configure3DModelScaleUnits,
    HistogramPictures,
    RepairAnalysisInfo,
    UploadNewItemDropArea,
    ModalView,
  },
  data() {
    return {
      currentAnalysisTool: "Canvas3D",
      repairModelIsOpen: false,
    };
  },
  computed: {
    ...mapGetters([
      "currentCartItem",
      "current3DFile",
      "currentViewport",
      "currentOrderProcessStep",
      "currentConfigure3DStep",
    ]),
  },
  methods: {
    minimizeCheckout() {
      location.reload();
    },
  },
  created() {
    let vm = this;

    if (this.current3DFile.repairInfo) {
      this.repairModelIsOpen = true;
    }
    eventBus.$on("openAnalysisTool", (tool) => {
      if (tool === "repairAnalysisInfo") {
        this.repairModelIsOpen = true;
      } else {
        vm.currentAnalysisTool = tool;
      }
    });
  },
};
</script>

<style scoped></style>
